import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Sanitizes raw SVG strings before injection via `[innerHTML]`.
 *
 * Internally trusts the input because the only consumer is the in-repo
 * `ICONS_REGISTRY`. Do not feed user-supplied SVG to this pipe.
 */
@Pipe({
  name: 'svgSanitizer',
  standalone: true,
})
export class SvgSanitizerPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(svg: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }
}
